import { render, staticRenderFns } from "./OfferDetails.vue?vue&type=template&id=389e2908&scoped=true"
import script from "./OfferDetails.vue?vue&type=script&lang=js"
export * from "./OfferDetails.vue?vue&type=script&lang=js"
import style0 from "./OfferDetails.vue?vue&type=style&index=0&id=389e2908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e2908",
  null
  
)

/* custom blocks */
import block0 from "./OfferDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports